// Modules
import { connect } from 'react-redux';
import React from 'react';
import VelocityTransitionGroup from 'velocity-react/velocity-transition-group';
import _ from 'lodash';

import { SVGButton } from 'components/widgets/buttons';
import { sidebarOffset } from 'constants';
import { slideClosed, slideOpen } from 'utils/transition-groups';
import Timer from 'services/data/timer';
import * as socket from 'services/socket';

import TimerElement from './timer.js';
import * as actions from './actions';

// Component
class Timers extends React.Component {
  constructor() {
    super();

    this.loadAllTimers = this.loadAllTimers.bind(this);
    this.loadFromSocket = this.loadFromSocket.bind(this);
  }

  componentDidMount() {
    socket.registerSocket('timer', this.loadFromSocket, this.loadAllTimers);

    this.loadAllTimers();
  }

  loadFromSocket(timer) {
    const { currentUser } = this.props;

    // Don't load other user's timers
    if (currentUser.id !== timer.createdBy.id) return;

    actions.update(timer, { skipUpdate: true, fromSocket: true });
  }

  loadAllTimers() {
    const { currentUser } = this.props;
    const query = Timer.formatQuery({ where: { createdBy: currentUser.id } });

    Timer.find(query).then(timers => actions.set({ timers }));
  }

  render() {
    const { timers, open } = this.props;

    const style = {
      bottom: 0,
      width: `calc(100% - ${sidebarOffset}px)`
    };

    const firstActive = _.find(timers, { status: 'Active' });

    return (
      <div className="timers-wrapper d-flex bg-white position-fixed" style={style}>
        <div>
          { !open && <SVGButton onClick={() => actions.set({ open: true })} src="svg/collapse.svg" className="btn-secondary rounded-circle p-2 m-2" /> }
          { open &&
            <div className="d-flex flex-column">
              <SVGButton onClick={() => actions.set({ open: false })} src="svg/expand.svg" className="btn-secondary rounded-circle p-2 m-2" />
              <SVGButton onClick={() => actions.add()} src="svg/add.svg" className="btn-secondary rounded-circle p-2 m-2" />
            </div>
          }
        </div>
        <div>
          { !open && !firstActive &&
            <div className="d-flex align-items-center">
              <SVGButton onClick={() => actions.add()} src="svg/add.svg" className="btn-secondary rounded-circle p-2 m-2" />
              <h3 className="mb-0 ml-2">No Timers</h3>
            </div>
          }
          { open && timers && !timers.length && <h3 className="mb-0 ml-2" style={{ paddingTop: '12px' }}>No Timers</h3> }
        </div>
        <VelocityTransitionGroup className="flex-grow" component="div" leave={slideClosed} enter={slideOpen}>
          { !open && firstActive && <TimerElement timer={firstActive} key={firstActive.uuid || firstActive.id} /> }
          { open && _.map(timers, timer => <TimerElement open timer={timer} key={timer.uuid || timer.id} />)}
        </VelocityTransitionGroup>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    timers: state.timers.timers,
    open: state.timers.open,
    currentUser: state.auth.currentUser
  };
}

// Exports
export default connect(mapStateToProps)(Timers);



// WEBPACK FOOTER //
// ./app/modules/timers/timers.js